<template>
  <v-dialog width="300px" v-model="showModal" persistent>
    <v-card>
      <v-card-title class="headline text-center">
        <strong>Cobrar transação</strong>
      </v-card-title>

      <v-card-text>
        <v-select
          v-model="creditCardId"
          :items="creditCards"
          item-text="nickname"
          item-value="id"
          label="Cartão:"
          required
        ></v-select>
        <v-text-field
          label="Número de Parcelas"
          v-model="installments"
          required
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="text-center align-center">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" @click="hideModal">Cancelar</v-btn>
        <v-btn color="green darken-1" @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserCreditCardController from '../../controllers/UserCreditCardController';
export default {
  props: {
    showModal: Boolean,
    transacao: Object,
    creditCardValid: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      userCreditCardController: new UserCreditCardController(this.$resource),
      creditCards: [],
      creditCardId: null,
      installments: 1,
    };
  },

  watch: {
    transacao: function() {
      this.clearForm();
      this.getUserCreditCard();
    },
  },

  methods: {
    async getUserCreditCard() {
      this.creditCards = await this.userCreditCardController.getAllByUserId(
        this.transacao.user.id,
        this.creditCardValid
      );
      let response = this.creditCards.find(
        creditCard => this.transacao.user_credit_card_id == creditCard.id
      );
      if (response) this.creditCardId = this.transacao.user_credit_card_id;
    },
    clearForm() {
      this.creditCardId = null;
      this.creditCards = [];
      this.installments = 1;
    },
    hideModal() {
      this.$emit('btnNao');
    },
    save() {
      let dados = {
        installments: this.installments,
        creditCardId: this.creditCardId,
      };
      this.$emit('btnSim', dados);
    },
  },
};
</script>
